import {
  createEmptyDuringRally,
  createEmptyDuringRallyEvents
} from './useMigration.js';

/**
 * Point watchers composable — auto-confirm watcher cascade.
 * Bridges useCurrentPoint and useScoring to break circular dependencies.
 * Bridge pattern: receives component instance during Options API phase.
 */
export function usePointWatchers(instance) {
  function setup() {
    instance.$watch('currentPoint.startPoint', (newOption) => {
      if (newOption === 'Receive') {
        instance.currentPoint.serveAction = {
          player: {},
          rating: null,
          call: null
        };
      } else if (newOption === 'Serve') {
        instance.currentPoint.receiveAction = {
          player: {},
          rating: null,
          call: null
        };
      }
      instance.syncRallyActive();
    });

    instance.$watch('currentPoint.serveAction.rating', (newRating) => {
      if (newRating === 4) {
        instance.currentPoint.scoreAction.outcome = 'Won';
        instance.currentPoint.scoreAction.pointDetail = 'Ace';
        instance.currentPoint.scoreAction.player = instance.currentPoint.serveAction.player;
        instance.currentPoint.duringRally = createEmptyDuringRally();
        instance.currentPoint.duringRallyEvents = createEmptyDuringRallyEvents();
        instance.autoConfirm();
      } else if (newRating === 0) {
        instance.currentPoint.scoreAction.outcome = 'Lost';
        instance.currentPoint.scoreAction.pointDetail = 'Serve error';
        instance.currentPoint.scoreAction.player = instance.currentPoint.serveAction.player;
        instance.currentPoint.duringRally = createEmptyDuringRally();
        instance.currentPoint.duringRallyEvents = createEmptyDuringRallyEvents();
        instance.autoConfirm();
      } else {
        if (!instance.currentPoint.serveAction.call) {
          instance.currentPoint.scoreAction.outcome = null;
          instance.currentPoint.scoreAction.pointDetail = '';
          instance.currentPoint.scoreAction.player = {};
        }
      }
      instance.syncRallyActive();
    });

    instance.$watch('currentPoint.serveAction.call', (newCall, oldCall) => {
      if (!newCall) {
        if (instance.currentPoint.serveAction.rating === 4 || instance.currentPoint.serveAction.rating === 0) {
          return;
        }
        if (oldCall) {
          instance.currentPoint.scoreAction.outcome = null;
          instance.currentPoint.scoreAction.pointDetail = '';
          instance.currentPoint.scoreAction.player = {};
        }
        instance.syncRallyActive();
        return;
      }
      if (newCall === 'Opposition Rotation Error') {
        instance.currentPoint.scoreAction.outcome = 'Won';
        instance.currentPoint.scoreAction.pointDetail = 'Opposition Rotation Error';
        instance.currentPoint.scoreAction.player = {};
        instance.currentPoint.duringRally = createEmptyDuringRally();
        instance.currentPoint.duringRallyEvents = createEmptyDuringRallyEvents();
        instance.autoConfirm();
      } else if (newCall === 'Rotation Error') {
        instance.currentPoint.scoreAction.outcome = 'Lost';
        instance.currentPoint.scoreAction.pointDetail = 'Rotation Error';
        instance.currentPoint.scoreAction.player = 'Team';
        instance.currentPoint.duringRally = createEmptyDuringRally();
        instance.currentPoint.duringRallyEvents = createEmptyDuringRallyEvents();
        instance.autoConfirm();
      }
      instance.syncRallyActive();
    });

    instance.$watch('currentPoint.receiveAction.rating', (newRating) => {
      if (newRating === 0) {
        instance.currentPoint.scoreAction.outcome = 'Lost';
        instance.currentPoint.scoreAction.pointDetail = 'Opp. ace';
        instance.currentPoint.scoreAction.player = instance.currentPoint.receiveAction.player;
        instance.autoConfirm();
      } else {
        if (!instance.currentPoint.receiveAction.call) {
          instance.currentPoint.scoreAction.outcome = null;
          instance.currentPoint.scoreAction.pointDetail = '';
          instance.currentPoint.scoreAction.player = {};
        }
      }
      instance.syncRallyActive();
    });

    instance.$watch('currentPoint.receiveAction.call', (newCall, oldCall) => {
      if (!newCall) {
        if (instance.currentPoint.receiveAction.rating === 0) {
          return;
        }
        if (oldCall) {
          instance.currentPoint.scoreAction.outcome = null;
          instance.currentPoint.scoreAction.pointDetail = '';
          instance.currentPoint.scoreAction.player = {};
        }
        instance.syncRallyActive();
        return;
      }
      if (newCall === 'Opposition Rotation Error') {
        instance.currentPoint.scoreAction.outcome = 'Won';
        instance.currentPoint.scoreAction.pointDetail = 'Opposition Rotation Error';
        instance.currentPoint.scoreAction.player = {};
        instance.autoConfirm();
      } else if (newCall === 'Rotation Error') {
        instance.currentPoint.scoreAction.outcome = 'Lost';
        instance.currentPoint.scoreAction.pointDetail = 'Rotation Error';
        instance.currentPoint.scoreAction.player = 'Team';
        instance.autoConfirm();
      }
      instance.syncRallyActive();
    });

    instance.$watch('currentPoint.receiveAction.player', (newPlayer) => {
      if (newPlayer && newPlayer.name === 'Opp. serve error') {
        instance.currentPoint.scoreAction.outcome = 'Won';
        instance.currentPoint.scoreAction.pointDetail = 'Opp. serve error';
      } else if (newPlayer === 'Team receive error') {
        instance.currentPoint.scoreAction.outcome = 'Lost';
        instance.currentPoint.scoreAction.pointDetail = 'Opp. ace';
        instance.currentPoint.scoreAction.player = 'Team';
      } else if (instance.currentPoint.receiveAction.rating === 0) {
        instance.currentPoint.scoreAction.player = newPlayer;
      }
    });

    instance.$watch('currentPoint.scoreAction.outcome', () => {
      instance.updatePreviewScore();
    });

    instance.$watch('score', () => {
      instance.updatePreviewScore();
    }, { deep: true });
  }

  return { setup };
}
